//noinspection JSFileReferences
import index from './favorites/index.js';

index.init();